"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var router_1 = require("@angular/router");
var root_category_summary_page_config_service_1 = require("../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var dynamic_navigation_helper_1 = require("../../common/utils/dynamic-navigation-helper");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
var RootCategoryDocumentsComponent = /** @class */ (function () {
    function RootCategoryDocumentsComponent(route, router, rootCategorySummaryPageConfigService) {
        this.route = route;
        this.router = router;
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.hasCreatePermission$ = Observable_1.Observable.of(false);
    }
    RootCategoryDocumentsComponent.prototype.ngOnInit = function () {
        var rootCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootCategoryId, this.route);
        var customPageUrl = this.router.url.split('/custom/')[1].split('?')[0];
        this.title$ = this.rootCategorySummaryPageConfigService.getCardConfigByCustomUrl(customPageUrl, rootCategoryId)
            .pipe(operators_1.map(function (config) { return config ? config.title : undefined; }), operators_1.shareReplay(1));
    };
    RootCategoryDocumentsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-root-category-documents',
            template: require('./root-category-documents.component.html'),
            styles: [require('./root-category-documents.component.css')],
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            router_1.Router,
            root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService])
    ], RootCategoryDocumentsComponent);
    return RootCategoryDocumentsComponent;
}());
exports.RootCategoryDocumentsComponent = RootCategoryDocumentsComponent;
//# sourceMappingURL=root-category-documents.component.js.map